<section id="product" class="evrn-method section">
  <div class="evrn-method__inner">
    <div class="container">
      <h2 class="evrn-method__title title-dark">The EVRN Method</h2>

      <p class="evrn-method__subtitle subheading-dark">
        We are removing the uncertainty from the generative video process. Giving complete control
        and consistency back to the maker.
      </p>
    </div>

    <app-auto-expandable-cards [cards]="steps" />
  </div>
</section>

<section class="evrn-method-video">
  <div class="evrn-method-video__inner">
    <app-youtube-player borderless videoUrl="https://www.youtube.com/watch?v=--0MbHMyvKM" />
  </div>
</section>
